export default __webpack_public_path__ + "static/media/gallery_03.5619c736.jpg";